var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"transfer-station"},[_c('UserPicker',{on:{"select":_vm.onUser}}),_c('button',{staticClass:"button",attrs:{"disabled":!_vm.user},on:{"click":_vm.transfer}},[_vm._v(_vm._s(_vm.$t("admin.transfer.button")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }